import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext } from 'react';
import { useRequestIds } from '~/context/srp/InventoryContext';
import useLoadedInventoryVehicles from '../useLoadedInventoryVehicles';

function useTrackMegaVehicle() {
  const { trackEvent } = useContext(AnalyticsContext);
  const requestIds = useRequestIds();
  const { loadedInventoryVehicles } = useLoadedInventoryVehicles();

  return useCallback(() => {
    trackEvent(
      'mega-srp-vehicle-data',
      {
        ...requestIds,
        vehicles: loadedInventoryVehicles.vehicles
      },
      undefined,
      {
        useFetch: true,
        fetchOption: { keepalive: false }
      }
    );
  }, [loadedInventoryVehicles.vehicles, requestIds, trackEvent]);
}

export default useTrackMegaVehicle;
